/// <reference path="../typings/jquery/jquery.d.ts" />
/// <reference path="../typings/bootstrap/bootstrap.d.ts" />
var TotalJobsGroup;
(function (TotalJobsGroup) {
    var Header;
    (function (Header) {
        var Toggles = (function () {
            function Toggles($) {
                this.$ = $;
            }
            Toggles.prototype.collapseToggles = function (holdingArray) {
                var $ = this.$;
                for (var i = 0; i < holdingArray.length; i++) {
                    var elementToClose = holdingArray[i];
                    var elementToCloseTargetName = $(elementToClose).attr("data-target");
                    var elementToCloseTarget = $(elementToCloseTargetName);
                    if (!$(elementToClose).hasClass("collapsed")) {
                        $(elementToCloseTarget).collapse("hide");
                    }
                }
            };
            Toggles.prototype.initialize = function () {
                var _this = this;
                var $ = this.$;
                // Reduce the transition duration fallback so that the menu appears and closes more quickly.
                $.fn.collapse.Constructor.TRANSITION_DURATION = 1;
                $(document).on("click", function (e) {
                    var $target = $(e.target);
                    // ignore if this click is inside a menu or a widget.
                    if ($target.closest(".navbar-collapse,.ui-widget").length > 0) {
                        return;
                    }
                    var $closestToggle = $target.closest(".navbar-toggle");
                    var $elementsToCollapse;
                    if ($closestToggle.length === 0) {
                        // click happened outside of .navbar-toggle, so close all open menus.
                        $elementsToCollapse = $(".navbar-toggle");
                    }
                    else {
                        // close navbars other than the one that was clicked.
                        $elementsToCollapse = $(".navbar-toggle").not($closestToggle);
                    }
                    _this.collapseToggles($elementsToCollapse);
                });
                // we want the nav to be collapsed when we go back. iOS uses the back /forward cache
                // so we need this event to fire when we go back. 
                // Before you say 'why didn't you bind to click?, we did, it sucked and messed up the menu animation.
                // The bbc news mobile nav does it like this so leave it alone.
                // I'm sure this won't stop you as people seem to love rewriting code in this project for no disernable benefit (apart from typing practise), so rock on.
                $(window).bind("pageshow", function (event) {
                    var $ = _this.$;
                    if ((event.originalEvent).persisted) {
                        var elementsToClose = $(".navbar-toggle");
                        _this.collapseToggles($(elementsToClose));
                    }
                });
            };
            return Toggles;
        }());
        Header.Toggles = Toggles;
    })(Header = TotalJobsGroup.Header || (TotalJobsGroup.Header = {}));
})(TotalJobsGroup || (TotalJobsGroup = {}));

//# sourceMappingURL=toggles.js.map
